import { Injectable, inject } from '@angular/core';
import { type ActivatedRouteSnapshot, type CanActivate, type CanMatch, type Route, Router, type UrlTree } from '@angular/router';

import { AuthService } from '../_services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanMatch, CanActivate {
  private authService = inject(AuthService);
  private router = inject(Router);

  canMatch(route: Route): boolean | UrlTree {
    return this.checkAccess(route.data?.['roles'], route.data?.['rolesRequireAll']);
  }

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    return this.checkAccess(route.data?.['roles'], route.data?.['rolesRequireAll']);
  }

  private checkAccess(allowedRoles?: string[], requireAll?: boolean): boolean | UrlTree {
    if (!this.authService.isLoggedInSync()) {
      console.warn('User is not authenticated. Redirecting to login.');
      return this.router.createUrlTree(['/login']);
    }
    if (!allowedRoles || allowedRoles.length === 0) {
      return true; // allow if no roles are defined
    }
    const hasAccess = requireAll ? this.authService.hasAllRoles(allowedRoles) : this.authService.hasAnyRole(allowedRoles);
    if (!hasAccess) {
      console.warn('Access denied. Redirecting to access-denied.');
      return this.router.createUrlTree(['/access-denied']);
    }

    return true;
  }
}
